var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyRupeeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.33333H10M6.66667 5.33333C6.92931 5.33333 7.18938 5.38507 7.43203 5.48557C7.67468 5.58608 7.89516 5.7334 8.08088 5.91912C8.2666 6.10484 8.41392 6.32532 8.51443 6.56797C8.61494 6.81062 8.66667 7.07069 8.66667 7.33333C8.66667 7.59598 8.61494 7.85605 8.51443 8.0987C8.41392 8.34135 8.2666 8.56183 8.08088 8.74755C7.89516 8.93326 7.67468 9.08058 7.43203 9.18109C7.18938 9.2816 6.92931 9.33333 6.66667 9.33333H6L8 11.3333M6 7.33333H10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2418 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2418 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupeeOutline);
export default __webpack_public_path__ + "static/media/CurrencyRupeeOutline.469ad53eb019b7bc86ec729752ef3a0d.svg";
export { ForwardRef as ReactComponent };